import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { Header } from './components/Header'
import { TitleContent } from './components/TitleContent'
import { List } from './components/listReport'
import { loadingCurrentPlan, selectFilterTrial } from './store/slice'
import { getTrialList, getUserPricingPackages } from './store/thunk'

export const CurrentPlan = () => {
  const dispatch = useDispatch()

  const loading = useSelector(loadingCurrentPlan('currentPlan'))
  const loadingPackage = useSelector(loadingCurrentPlan('pricingPackage'))
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const filter = useSelector(selectFilterTrial)

  useEffect(() => {
    dispatch(getUserPricingPackages())
  }, [locale])

  useEffect(() => {
    userType.userTypeId === USER_TYPE.TRIAL &&
      dispatch(
        getTrialList({
          Page: filter.page,
          PageSize: filter.pageSize,
        }),
      )
  }, [locale, JSON.stringify(filter)])

  return (
    <LayoutPanel loading={loading || loadingPackage}>
      <div className="flexColumn h100 justifyContentBetween">
        <Header />
        <TitleContent />
        <List />
      </div>
    </LayoutPanel>
  )
}
